// extracted by mini-css-extract-plugin
export default {"header":"TopHeader_header__6gLVW","title":"TopHeader_title__Rc6MQ"};